<template>
  <b-card class="errorpage-card">
    <section>
      <header class="text-align-center">
        <img class="brand" src="@/assets/logo.png" />
      </header>
      <div class="body">
        <h1 class="display-3 mr-4">404</h1>
        <p class="text-muted auth-message">Sorry, that page could not be found.</p>
        <br/>
        <b-link :to="{name: 'Dashboard'}">
          <b-button variant="success">Return to Dashboard</b-button>
        </b-link>
      </div>
    </section>
  </b-card>
</template>

<script>
export default {
  name: 'Page404',
  beforeCreate () {
    document.body.classList.add('error-page')
  },
  beforeDestroy () {
    document.body.classList.remove('error-page')
  }
}
</script>
